import { DefaultIconProps } from './types';
import { POWER_ICON_URL } from './urls';

export const PowerIcon = ({ className, ...props }: DefaultIconProps) => (
  <img
    className={className}
    src={POWER_ICON_URL}
    alt="power-icon"
    {...props}
  />
);
